import { RepositoryFileSearchResponse } from "./types";

interface BackendFilesResponse {
  owner: string;
  repository: string;
  workspaceKey: string;
  items?: Array<{ path: string; name: string; extension?: string }>;
  page?: { nextCursor?: string | null };
  total?: number;
}

export const adaptFilesResponse = (
  raw: BackendFilesResponse,
  cursor: number
): RepositoryFileSearchResponse => ({
  owner: raw.owner,
  repository: raw.repository,
  workspaceKey: raw.workspaceKey,
  nodes: (raw.items || []).map((item) => ({
    path: item.path,
    name: item.name,
    type: "file",
    extension: item.extension,
  })),
  cursor,
  nextCursor: raw.page?.nextCursor ? Number(raw.page.nextCursor) : null,
  total: raw.total || 0,
});
